<div class="settings">
    <mat-slide-toggle color="primary" [checked]="widget.options_dict.person"
                      [(ngModel)]="widget.options_dict.person">
    <span class="settings-label">
      {{ 'WIDGETS.SETTINGS_LABELS.MY_PERSONAL' | translate }}
    </span>

    </mat-slide-toggle>
</div>

